/** Idle orbit re-solves overlap at this interval. Seats still ease every frame. */
export const IDLE_CLEAR_MS = 200;

/**
 * Full overlap solve while the user is moving the view, a layout is in
 * flight, or ignition is playing. Idle drift solves on IDLE_CLEAR_MS.
 */
export function wantsClearanceSolve({
  manualClear,
  nodesMoving = false,
  igniting = false,
  now,
  clock,
}) {
  if (manualClear || nodesMoving || igniting) {
    clock.idleClearAt = null;
    return true;
  }
  const last = clock.idleClearAt;
  if (last == null || now - last >= IDLE_CLEAR_MS) {
    clock.idleClearAt = now;
    return true;
  }
  return false;
}
